import { catchError, of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ConfirmPasswordValidator, PasswordPatternValidator } from '../../validators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PasswordService } from '../../services';
import { SubSink } from 'subsink';

@Component({
  selector: 'omn-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  private readonly subs = new SubSink();

  hideCurrent = true;
  hideNew = true;
  hideConfirm = true;

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private passwordService: PasswordService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private snackBar: MatSnackBar,
  ) { }

  get currentPassword() {
    return this.form.get('currentPassword');
  }

  get password() {
    return this.form.get('password');
  }

  get confirmPassword() {
    return this.form.get('confirmPassword');
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      currentPassword: ['', [Validators.required]],
      password: ['', [Validators.required, PasswordPatternValidator]],
      confirmPassword: ['', [Validators.required, ConfirmPasswordValidator]]
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  save(): void {
    this.subs.sink = this.passwordService
      .post(this.currentPassword?.value, this.password?.value)
      .pipe(catchError(() => of(false)))
      .subscribe(result => {
        this.snackBar.open(result !== true
          ? 'Could not change the password.'
          : 'Password changed!', 'Close', {
            duration: 2500,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });

        if (result) {
          this.dialogRef.close();
        }
      });
  }

}
